import { Filter, SearchRequest, Sort } from '@blk/wealth-web-endpoint';

import { FilterRequest, SecuritySearchRequest, SortRequest } from './security-search-request.model';

export const mapSecuritySearchRequestToSearchRequest = (securitySearchRequest: SecuritySearchRequest) => {
	return {
		query: securitySearchRequest.query,
		filters: securitySearchRequest.filters ? securitySearchRequest.filters.map(mapFilterRequestToFilter) : [],
		facets: securitySearchRequest.facets,
		sort: securitySearchRequest.sort ? mapSortRequestToSort(securitySearchRequest.sort) : null,
		limit: securitySearchRequest.limit
	} as SearchRequest;
};

export const mapFilterRequestToFilter = (filterRequest: FilterRequest) => {
	return {
		field: filterRequest.field,
		values: filterRequest.values,
		range: filterRequest.range,
		negate: filterRequest.negate
	} as Filter;
};

export const mapSortRequestToSort = (sortRequest: SortRequest) => {
	return {
		field: sortRequest.field,
		sort: Sort[sortRequest.sort.toString()]
	} as Sort;
};
